export const GOOGLE_MAPS_API_KEY = 'AIzaSyBzRcDwV2mi6Kjb1T4DRkqcXwPJj9Yz5VQ';
export const GOOGLE_MAPS_LIBRARIES: ("drawing" | "places" | "marker")[] = ['places', 'drawing', 'marker'];
// Pinned below 3.65, where Google removed the `drawing` library (DrawingManager).
// Temporary: replace DrawingManager with manual polygon drawing, then drop this pin.
export const GOOGLE_MAPS_VERSION = '3.63';
export const DEFAULT_MAP_OPTIONS = {
  center: { lat: -33.45694, lng: -70.64827 }, // Default to Santiago, Chile
  zoom: 12,
  disableDefaultUI: true,
  zoomControl: true,
  mapTypeControl: false,
  streetViewControl: false,
  fullscreenControl: true,
  mapId: 'DEMO_MAP_ID', // Required for advanced markers
} as const;